<template>
    <div class="employee-discount text-center mb-3">
        <form :action="applyEmployeeDiscountUrl">
            <div v-html="courseDetailsFields"></div>
            <input v-if="removeDiscount == 1" type="hidden" name="remove_discount" value="1">

            <div class="row justify-content-center">
                <div class="col-md-9">
                    <div class="ml-2 text-right">
                        {{ tra.employee_discount }} | <small>{{ tra.institute_currency }} ({{ (dataObj.course?.institute_currency) || 'SAR' }})</small>
                        <input
                            :style="'border: 1px solid #e7e7e7; height: 30px !important; border-radius: 5px; padding-right:10px; width: 100%;'"
                            type="number" 
                            :max="employeeDiscountType == 'percentage' ? 100 : ''"
                            v-model="localEmployeeDiscountValue" 
                            name="employee_dsicount"
                            @input="$emit('update-discount-value', $event.target.value)"
                        >
                        <small>{{ tra.fixed_discount_value_note }}</small>
                    </div>
                </div>
            </div>
            
            <hr class="my-2">
            
            <div class="ml-4 d-inline-flex align-items-center">
                <span class="d-inline-flex align-items-center mx-3">
                    {{ tra.percentage }}
                    <input 
                        class="mr-2" 
                        @change="$emit('update-discount-type')" 
                        v-model="localEmployeeDiscountType"
                        value="percentage" 
                        type="radio" 
                        name="employee_discount_type"
                        style="height: 15px; width: 15px;"
                    >
                </span>
                <span class="d-inline-flex align-items-center">
                    {{ tra.fixed_value }}
                    <input 
                        class="mr-2" 
                        @change="$emit('update-discount-type')" 
                        v-model="localEmployeeDiscountType"
                        value="fixed" 
                        type="radio" 
                        name="employee_discount_type" 
                        style="height: 15px; width: 15px;"
                    >
                </span>
            </div>
            
            <div class="ml-4 d-inline-flex align-items-center">
                <button class="ml-xl-4 btn rounded-10 bg-secondary-color text-white" type="submit">
                    {{ tra.apply_discount }}
                </button>
                <button 
                    @click="$emit('remove-discount')" 
                    class="ml-xl-4 btn rounded-10 bg-danger text-white" 
                    type="button"
                >
                    {{ tra.cancel_discount }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'EmployeeDiscountForm',
    props: {
        employeeDiscount: [String, Number],
        employeeDiscountType: String,
        employeeDiscountValue: [String, Number],
        removeDiscount: [String, Number],
        applyEmployeeDiscountUrl: String,
        courseDetailsFields: String,
        tra: Object,
        dataObj: Object,
    },
    emits: ['update-discount-type', 'update-discount-value', 'remove-discount'],
    computed: {
        localEmployeeDiscountType: {
            get() {
                return this.employeeDiscountType;
            },
            set(value) {
                this.$emit('update-discount-type', value);
            }
        },
        localEmployeeDiscountValue: {
            get() {
                return this.employeeDiscountValue;
            },
            set(value) {
                this.$emit('update-discount-value', value);
            }
        }
    }
};
</script>